import * as Yup from 'yup';

export const cronRegex =
  /^(\*|([0-5]?[0-9]))\s+(\*|([01]?[0-9]|2[0-3]))\s+(\*|([12]?[0-9]|3[01]))\s+(\*|([01]?[0-9]|1[0-2]))\s+(\*|([0-6]))$/;

export default Yup.object().shape({
  Name: Yup.string().max(255).required().label('Name'),
});
